import request, { serviceV2 } from '@/utils/request'

const CDNPath = process.env.VUE_APP_QINIU_DOMAIN

export default {
  getWxApiTicket: (url) => {
    return request.get('/wechat-jsapi-ticket/', { params: { url: url } })
  },
  getWeComApiTicket: (weComAppId, url) => {
    return request.get(`/wecom/api/app/${weComAppId}/jsapi-ticket/`, { params: { url } })
  },
  changeLanguage: (language) => {
    const lan = new FormData()
    lan.append('language', language)
    return request.post('/i18n/setlang/', lan)
  },
  getQiniuUploadToken: (params) => {
    return request.get('/django_rest/common/qiniu_upload_token', { params })
  },
  saveCommonUserBehavior: (jobId) => {
    return request.get(`/common-trigger/${jobId}/`)
  },
  compressVideo: (params) => {
    return request.post('/django_rest/job_poster_compress/', params)
  },
  watermarkVideo: (params) => {
    return request.post('/django_rest/job_poster_watermark/', params)
  },
  getMediaPrefopStatus: (params) => {
    const { persistentId, posterUniqueKey } = params
    const uniqueKey = (posterUniqueKey && `posterUniqueKey=${posterUniqueKey}`) || ''
    const param = `persistentId=${persistentId}&${uniqueKey}`
    return request.get(`/django_rest/get_video_status/?${param}`)
  },
  getMediaInfo: (key) => {
    return request.get(`${CDNPath}${key}?avinfo`)
  },
  batchDeletePosterImage: (params) => {
    return request.post('/django_rest/delete_poster_watermark_image/', params)
  },
  trackWeChatShare: (params) => {
    return request.post('/django_rest/event-track/candidate/wx-share/', params)
  },
  getCurrencyList: () => {
    return request.get('/django_rest/currency/')
  },
  getCountryCodeList () {
    return request.get('/django_rest/country-code/')
  },
  getTimeZoneList (params) {
    return request.get('/get-timezone/', { params })
  },
  getPrivateFileUrl (params) {
    return request.get('/django_rest/company/private_file/', { params })
  },
  checkHoliday () {
    return request.get('/django_rest/holiday-logo-check/')
  },
  getOSSUploadToken (params) {
    return serviceV2.get('/common/upload-token/', { params })
  }
}
